import React, {useState} from 'react';
import {View, Text, StyleSheet} from 'react-native';
import TitleBlock from '../../components/TitleBlock';
import FormAQSMI from '../../form/FormAQSMI';
import Themes from '../../themes';
import {isPositiveNumber, currencyFormat} from '../../utils';

const SimuAQSMI = ({navigation}) => {
  const [resultats, setResultats] = useState([]);

  const form = (
    <View style={[styles.scene]}>
      <FormAQSMI setResultat={setResultats} />
    </View>
  );

  const results = (
    <View style={[styles.scene]}>
      {resultats.map((resultat) => (
        <View style={[styles.resultItem]}>
          <View style={[styles.blockTitle]}>
            <View style={[styles.title]}>{resultat.title}</View>
            <View style={[styles.subtitle]}>{resultat.subtitle}</View>
          </View>

          <View style={[styles.graph]}>
            <View
              style={[
                styles.graphData,
                {
                  backgroundColor: resultat.color,
                  width: `${resultat.percent * 5}%`,
                },
              ]}></View>
          </View>
          <View style={[styles.resultCalcul]}>
            {currencyFormat(resultat.value)}
          </View>
        </View>
      ))}
    </View>
  );

  return (
    <>
      {form}
      {results}
    </>
  );
};

const styles = StyleSheet.create({
  scene: {
    flex: 1,
    padding: 20,
  },
  resultItem: {
    flexDirection: 'row',
    marginBottom: 10,
    alignItems: 'center',
    flex: 1,
  },
  blockTitle: {
    borderRightWidth: 1,
    borderRightColor: '#000',
    textAlign: 'right',
    paddingRight: 5,
    flex: 2,
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: 22,
  },
  subtitle: {
    fontSize: 16,
    lineHeight: 20,
    color: 'gray',
  },
  graph: {
    flex: 2,
    paddingHorizontal: 10,
  },
  graphData: {
    height: 50,
    maxWidth: '100%',
  },
  resultCalcul: {
    textAlign: 'left',
    marginLeft: 15,
    flex: 1,
  },
});

export default SimuAQSMI;
